


















































import {
    Component,
    Vue
} from 'vue-property-decorator';

import auth from '../common/auth';
import axios from '../common/api';

@Component({
    components: {},
})
export default class Index extends Vue {
    form={
        email:'',
        code:''
    }
    newpwd:string =''
    pwdagain:string = ''
    countdown:number= 0
    sent:boolean = false
    step: number = 1
    created() {
        document.title = '登录 - EssayDoctor 文书工作室'  
    }
    sendVerify(){
        if(!this.form.email){
            this.$message.warning('请输入邮箱')
            return
        }
        axios.post('/sendverify',{email:this.form.email}).then(res=>{
            this.$message.success('邮件发送成功，请去邮箱查阅')
            this.countdown = 60
            let timer = setInterval(()=>{
                this.countdown--
                if(this.countdown<=0){
                    clearInterval(timer)
                }
            },1000)
            setTimeout(() => {
                this.sent = true
            }, 1000);

        }).catch(e=>{
            this.$message.error('邮件发送失败，请检查邮箱是否正确')
        })
    }
    // nextStep(){
    //     axios.post('/verifycode',this.form).then(res=>{
    //         if(res.data != 200){
    //             this.$message.error('验证码错误')
    //         }else{
    //             this.step = 2
    //         }
    //     })
    // }
    submit(){
        if(!this.form.email){
            this.$message.error('请输入邮箱')
        } else if(!this.form.code){
            this.$message.error('请输入验证码')
        } else if(!this.newpwd){
            this.$message.error('请输入新密码')
        } else if(this.newpwd !==this.pwdagain){
            this.$message.error('两次输入密码不相同')
        } else {
            axios.post('/resetpwd',{
                ...this.form,
                pwd: this.newpwd
            }).then(res=>{
                this.$message.success('密码修改成功！')
                this.$router.replace('/login')
            }).catch(e=>{
                this.$message.error('密码修改失败')
                
            })
        }
    }
    
}
